module.exports = __webpack_public_path__ + "img/premium.5035fac0.png";